import {
  Box,
  Container,
  Flex,
  HStack,
  Icon,
  IconButton,
  Link,
  VStack,
} from "@chakra-ui/react"
import FooterWorldMap from "@components/blocks/FooterWorldMap"
import FooterButtons from "@components/buttons/contact/FooterButtons"
import MenuLink from "@components/nav/MenuLink"
import { NavItems, OtherLinks, SocialLinks } from "@data/nav"
import SVGMasterCard from "@public/svg/footer/mastercard.svg"
import SVGVisa from "@public/svg/footer/visa.svg"
import SvgKptacLogo from "@public/svg/kptac-logo.svg"
import { useRouter } from "next/router"
import { useTranslations } from "next-intl"
import {
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoYoutube,
} from "react-icons/io5"

export default function Footer() {
  const { pathname } = useRouter()
  const t = useTranslations("nav")

  return (
    <>
      <Container
        as={"footer"}
        maxW={"container.xl"}
        mt={24}
        mb={40}
        borderTopWidth={1}
        borderColor={"brand.primary"}
      >
        <FooterWorldMap />
        <VStack spacing={2}>
          <Flex
            w={"full"}
            flexWrap={"wrap"}
            justifyContent={"center"}
            alignItems={"center"}
            mt={8}
          >
            <MenuLink
              href={"/"}
              label={t("home")}
              fontSize={"sm"}
              fontWeight={400}
              textTransform={"none"}
              color={pathname === "/" ? "white" : "brand.primary"}
              me={{ base: 0, md: 4 }}
            />
            {NavItems.map((navItem, index) => (
              <MenuLink
                href={navItem.href ?? "#"}
                label={t(navItem.label)}
                key={index}
                fontSize={"sm"}
                fontWeight={400}
                textTransform={"none"}
                color={pathname === navItem.href ? "white" : "brand.primary"}
                me={{ base: 0, md: 4 }}
              />
            ))}
          </Flex>
          <Flex>
            {OtherLinks.map((navItem, index) => (
              <MenuLink
                href={navItem.href ?? "#"}
                label={t(navItem.label)}
                key={index}
                fontSize={"sm"}
                fontWeight={400}
                textTransform={"none"}
                color={pathname === navItem.href ? "white" : "brand.primary"}
              />
            ))}
          </Flex>
          <Flex alignItems={"center"}>
            {SocialLinks.map((navItem, index) => (
              <Link
                href={navItem.href ?? "#"}
                key={index}
                isExternal
              >
                <IconButton
                  aria-label={t(navItem.label)}
                  bg={"transparent"}
                  color={navItem.label}
                  size={"lg"}
                  icon={
                    navItem.label === "instagram" ? (
                      <IoLogoInstagram />
                    ) : navItem.label === "facebook" ? (
                      <IoLogoFacebook />
                    ) : navItem.label === "youtube" ? (
                      <IoLogoYoutube />
                    ) : (
                      <IoLogoLinkedin />
                    )
                  }
                />
              </Link>
            ))}
          </Flex>
          <Flex
            alignItems={"center"}
            mt={4}
          >
            <Icon
              as={SVGVisa}
              w={8}
              h={8}
              mx={2}
            />
            <Icon
              as={SVGMasterCard}
              w={8}
              h={8}
              mx={2}
            />
          </Flex>
          <Box
            w={"full"}
            textAlign={"center"}
            fontSize={"xs"}
            mt={10}
          >
            {t("copyright")} &copy; {new Date().getFullYear()}
            {" | "}
            {t("all_rights_reserved")}
          </Box>
          <HStack
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Box
              w={"full"}
              textAlign={"center"}
              fontSize={"xs"}
            >
              {t("powered_by")}
            </Box>
            <Link
              href={"https://www.kptac.com"}
              target={"_blank"}
              aria-label={"company link"}
              title={"KPTAC Technologies"}
              lineHeight={1}
            >
              <Icon
                as={SvgKptacLogo}
                width={{ base: 16 }}
                height={"auto"}
              />
            </Link>
          </HStack>
        </VStack>
      </Container>
      <FooterButtons />
    </>
  )
}
